import { render, staticRenderFns } from "./MonitoringRehabilitators.vue?vue&type=template&id=5cbc8f02&scoped=true&"
import script from "./MonitoringRehabilitators.vue?vue&type=script&lang=js&"
export * from "./MonitoringRehabilitators.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringRehabilitators.vue?vue&type=style&index=0&id=5cbc8f02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc8f02",
  null
  
)

export default component.exports